export default __webpack_public_path__ + "static/media/Rap.6b90a0e0.svg";